import request from '@/utils/request'

// 报价与支持银行都由保险平台返回；保留业务错误响应，便于页面显示失败原因并允许重试。
export function getInsurancePrices(data) {
  return request({
    url: '/bxpt/product/price',
    method: 'POST',
    headers: { needToken: true, loading: false },
    returnErrorResponse: true,
    data,
  })
}

export function getInsuranceBanks(data) {
  return request({
    url: '/bxpt/bank/list',
    method: 'POST',
    headers: { needToken: true, loading: false },
    returnErrorResponse: true,
    data,
  })
}

// 短信会话由绑卡申请返回；重发与确认沿用同一次申请的会话及支付渠道。
export function applyBindCard(data) {
  return request({
    url: '/bxpt/bind-card/apply',
    method: 'POST',
    headers: { needToken: true, loading: false },
    returnErrorResponse: true,
    data,
  })
}

export function resendBindCardSms(data) {
  return request({
    url: '/bxpt/bind-card/resend-sms',
    method: 'POST',
    headers: { needToken: true, loading: false },
    returnErrorResponse: true,
    data,
  })
}

export function confirmBindCard(data) {
  return request({
    url: '/bxpt/bind-card/confirm',
    method: 'POST',
    headers: { needToken: true, loading: false },
    returnErrorResponse: true,
    data,
  })
}

// 确认投保保留业务返回状态，由结果页展示，不将预投保或扣款中误判为投保成功。
export function confirmInsure(data) {
  return request({
    url: '/bxpt/confirm-insure',
    method: 'POST',
    headers: { needToken: true, loading: false },
    returnErrorResponse: true,
    data,
  })
}

// 结果页按登录用户查询最新保险状态，不沿用投保提交时可能已过期的状态。
export function getInsuranceResult() {
  return request({
    url: '/bxpt/result',
    method: 'GET',
    headers: { needToken: true, loading: false },
    returnErrorResponse: true,
  })
}
